/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable object-curly-newline */
/* eslint-disable no-void */
/* eslint-disable arrow-body-style */
/* eslint-disable no-console */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-alert */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-return-assign */
/* eslint-disable max-len */
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";

import { MESSAGE_KIND_GET } from "../../../Constants";
import Environments from "../../../Environments";
import MOCK_DATA from "../../../mock/data";

import NoData from "../../../component/NoData";
import ToListButton from "../../../component/button/ToListButtonVertical";
import SompoLoading from "../../../component/loading/SompoLoading";
import { useScreenSize } from "../../../component/Theme";
import WhatsNewIcon from "../../../component/icons/WhatsNewIcon";

import NoticeMessageListService, { NoticeMessageListResponse, MsgListItem } from "../../../logic/api/NoticeMessageListService";
import NoticeWhatsNewService, { NoticeWhatsNewResponse, WhatsNewListItem } from "../../../logic/api/NoticeWhatsNewService";
import { datetime2DateJP } from "../../../logic/datetime";
import { isNew } from "../../../logic/information/Information";
import { getTextFromHTML } from "../../../logic/text";
import { showErrorMessage } from "../../../logic/hook/useDialogStateHelper";
import { desc } from "../../../logic/utility/sort";
import SompoContext from "../../../logic/context/SompoContext";

const messageService = new NoticeMessageListService();
const whatsService = new NoticeWhatsNewService();

interface InfoItem {
    messageId: string;
    startDateStr: string;
    title: string;
    message: string;
    whatsNew?: boolean;
}

function convertMessage(messageList: string[]) {
    if (messageList === null || messageList.length === 0) {
        return "";
    }
    // 各配列の文字列を結合
    const allMessage = messageList.join("");
    return allMessage;
}

const Information = () => {
    const { desktop } = useScreenSize();
    const navigate = useNavigate();
    const sompoContext = React.useContext(SompoContext);
    const [info, setInfo] = useState<InfoItem[]>([]);

    useEffect(() => {
        const newInfo: InfoItem[] = [];
        if (!Environments.MOCK) {
            const fetch = async () => {
                try {
                    // メッセージ一覧を取得
                    await messageService.noticeMessageList(
                        { kind: MESSAGE_KIND_GET },
                        (_info: NoticeMessageListResponse) =>
                            (_info.msgList || []).forEach((datum: MsgListItem) => {
                                newInfo.push({
                                    messageId: datum.messageId,
                                    startDateStr: datum.startDateStr,
                                    title: datum.title,
                                    message: convertMessage(datum.messageList),
                                });
                            }),
                        (error: any) => {
                            throw error;
                        }
                    );

                    // What's New一覧を取得
                    await whatsService.noticeWhatsNew(
                        {},
                        (_info: NoticeWhatsNewResponse) =>
                            (_info.whatsNewList || []).forEach((datum: WhatsNewListItem) => {
                                newInfo.push({
                                    whatsNew: true,
                                    messageId: datum.messageId,
                                    startDateStr: datum.startDateStr,
                                    title: datum.titleList[0],
                                    message: convertMessage(datum.messageList),
                                });
                            }),
                        (error: any) => {
                            throw error;
                        }
                    );
                    setInfo(newInfo.sort((a, b) => desc(a.startDateStr, b.startDateStr)));
                } catch (error: any) {
                    console.error(error);
                    showErrorMessage({ message: "お知らせの取得に失敗しました。", error });
                    setInfo([]);
                }
            };
            void fetch();
        } else {
            (MOCK_DATA.INFORMATION.whatsNewList || []).forEach((datum: WhatsNewListItem) => {
                newInfo.push({
                    whatsNew: true,
                    messageId: datum.messageId,
                    startDateStr: datum.startDateStr,
                    title: datum.titleList[0],
                    message: convertMessage(datum.messageList),
                });
            });
            (MOCK_DATA.INFORMATION.msgList || []).forEach((datum: MsgListItem) => {
                newInfo.push({
                    messageId: datum.messageId,
                    startDateStr: datum.startDateStr,
                    title: datum.title,
                    message: convertMessage(datum.messageList),
                });
            });
            setInfo(newInfo.sort((a, b) => (a.startDateStr < b.startDateStr ? 1 : -1)));
        }
    }, []);
    return (
        <Box
            sx={{
                width: "100%",
                height: "auto",
            }}
        >
            <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", pb: 2 }}>
                <Typography variant="h5">お知らせ</Typography>
                <ToListButton navigateUrl={"/information"} />
            </Box>
            <List
                sx={{
                    width: "100%",
                    height: "auto",
                    minHeight: "100px",
                    p: 0,
                    position: "relative",
                    display: "flex",
                    flexDirection: desktop ? "column" : "row",
                    overflowY: desktop ? "auto" : "scroll",
                }}
            >
                {sompoContext.loading ? (
                    <SompoLoading />
                ) : (
                    <>
                        {info && info.length > 0 ? (
                            <>
                                {info.slice(0, 3).map((row, index) => {
                                    let detail: string;
                                    switch (row.whatsNew) {
                                        case true:
                                            detail = "whatsnew";
                                            break;
                                        default:
                                            detail = "message";
                                    }
                                    return (
                                        <Box key={index} sx={{ width: "100%" }}>
                                            <ListItem
                                                key={index}
                                                sx={{
                                                    p: 0,
                                                    width: "100%",
                                                    height: "auto",
                                                }}
                                            >
                                                <ListItemButton
                                                    sx={{
                                                        transition: "all 0.18s ease-in-out",
                                                        height: "auto",
                                                        "&:hover": {
                                                            bgcolor: "#ddd",
                                                            cursor: "pointer",
                                                            width: "100%",
                                                        },
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        borderRadius: "10px",
                                                        bgcolor: "#fff",
                                                        mb: desktop ? 2 : 0,
                                                        mr: desktop ? 0 : 1,
                                                        p: 2,
                                                    }}
                                                    onClick={() => {
                                                        navigate(`/information/${detail}/${row.messageId}`);
                                                    }}
                                                >
                                                    <Grid container direction="column">
                                                        <Grid item sx={{ display: "flex", alignItems: "center" }}>
                                                            {isNew(row.startDateStr) && <WhatsNewIcon />}
                                                            <Typography variant="body2" sx={{ ml: 1, whiteSpace: desktop ? "normal" : "nowrap" }}>
                                                                {datetime2DateJP(row.startDateStr)}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Typography
                                                                className="ellipses"
                                                                variant="h6"
                                                                sx={{
                                                                    fontWeight: "bold",
                                                                    mt: 1,
                                                                    whiteSpace: "normal",
                                                                    wordBreak: "break-all",
                                                                }}
                                                            >
                                                                {getTextFromHTML(row.title)}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </ListItemButton>
                                            </ListItem>
                                        </Box>
                                    );
                                })}
                            </>
                        ) : (
                            <NoData message="表示データがありません" />
                        )}
                    </>
                )}
            </List>
        </Box>
    );
};

export default Information;
